import React from 'react';

const Footer = () => {
  return (
    <footer className="py-8 px-6 border-t border-neutral-200 dark:border-white/10 mt-16">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <span className="font-mono text-xs text-neutral-500 uppercase tracking-widest">
          © {new Date().getFullYear()} Romain GDR. All rights reserved.
        </span>
        <div className="flex items-center gap-6">
          <a href="https://www.linkedin.com/in/romain-g-4ab64b28b/" className="font-mono text-xs text-neutral-500 hover:text-neutral-900 dark:hover:text-white transition-colors uppercase tracking-widest">
            LinkedIn
          </a>
          <a href="https://github.com/romaingdr" className="font-mono text-xs text-neutral-500 hover:text-neutral-900 dark:hover:text-white transition-colors uppercase tracking-widest">
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
